import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { HelpCenterSettingsWidgetConfigurationAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-widget-configuration/entrypoint.tsx';

export const HelpCenterSettingsWidgetConfigurationEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
